import { Component, Vue, Prop } from "vue-property-decorator";
import { NOTIFICATION } from "@/constants";
import { NotificationDTO } from "@/store/modules/notification";

@Component
export default class NotificationSnackbar extends Vue {
  @Prop() notification: NotificationDTO;
  @Prop() index: number;
  private constNotification = NOTIFICATION;
  private heightBefore = 0;
  private display = true;
  
    
  public heightNotification(): number {
    const elementNotification = this.$refs.notification as any;
    if (elementNotification) {
      return elementNotification.clientHeight;
    }
    return 0;
  }

  public sumHeightBefore(index: number): number {
    let result = 0;
    const heights = this.$store.getters['notification/notificationHeight'];
    heights.map((height: number, i: number) => {
      if (index > i) {
        result = result + height;
      }
    });
    return result;
  }

  public disableDisplay(): void {
    this.display = false;
  }
  beforeMount(): void {
    if (this.index > 0) {
      this.heightBefore = this.sumHeightBefore(this.index);
    }
  }

  mounted(): void {
    if (this.notification.height === 0) {
      this.$store.commit('notification/updateNotificationHeight', {
        index: this.index,
        height: this.heightNotification() + 28,
      })
    }
  }
  
  updated(): void {
    if (!this.display && this.notification.showing) {
      this.$store.commit('notification/updateNotificationShowing', this.index);
    }
  }

}
